import { PerformedByRequestDTO } from './performed-by-request-dto';
import { ResponseDTO } from './response-dto';

export interface CheckUserEmailRequestDTO extends PerformedByRequestDTO {
    userEmail?: string;
}

export interface CheckUserEmailResponseDTO extends ResponseDTO {
    exist?: boolean;
}
